import { createContext, type ReactNode, useContext } from 'react';
import type { ResolvedHotelContext } from './slug-resolution';

/**
 * Provides the resolved tenant/hotel context (UUIDs, names, timezone,
 * membership) to all hotel-scoped pages. Set once by the hotel layout route
 * after slug resolution + the RBAC/ABAC guard pass.
 */
const HotelContext = createContext<ResolvedHotelContext | null>(null);

export function HotelContextProvider({
  value,
  children,
}: {
  value: ResolvedHotelContext;
  children: ReactNode;
}) {
  return <HotelContext.Provider value={value}>{children}</HotelContext.Provider>;
}

export function useHotelContext(): ResolvedHotelContext {
  const ctx = useContext(HotelContext);
  if (!ctx) throw new Error('useHotelContext must be used within a hotel-scoped route');
  return ctx;
}
